import React from 'react';
import { SectionTitle } from './SectionTitle';
import { Chips } from './Chips';
import { bonuses } from '../data/salesCopy';
export function BonusSection() {
  return <section className="bg-brand-ivoryLight px-4 py-8 sm:py-10" data-id="element-51" data-mp="1oi811bi6d428">
      <div className="mx-auto max-w-4xl" data-id="element-52" data-mp="22f3fxkl3xpq7">
        <SectionTitle data-id="element-53" data-mp="1ye1m5j9ym5vm">🎁 5 PREMIUM BONUSES INCLUDED</SectionTitle>

        <div className="mt-5 grid gap-3 lg:grid-cols-2" data-id="element-54" data-mp="1yet7805xkl7n">
          {bonuses.map(bonus => <article key={bonus.n} className="flex flex-col overflow-hidden rounded-lg border-2 border-brand-gold/50 bg-white shadow-sm" data-id="element-55" data-mp="1aop7i3vv55lx">
              <header className="flex items-center gap-2.5 border-b border-brand-gold/40 bg-brand-sand/25 px-3 py-2" data-id="element-56" data-mp="1jhkd4yp8t3c8">
                <span className="shrink-0 rounded bg-brand-gold px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wider text-brand-charcoal" data-id="element-57" data-mp="1eorbijp2mb4d">
                  🎁 Bonus {bonus.n}
                </span>
                <h3 className="font-serif text-[14px] font-extrabold uppercase leading-tight text-brand-sage sm:text-base" data-id="element-58" data-mp="mws5t5m4ntyj">
                  {bonus.title}
                </h3>
              </header>

              <div className="flex flex-1 flex-col gap-2 p-3" data-id="element-59" data-mp="2ep37dm5kwm0p">
                <p className="text-[12.5px] font-bold leading-snug text-brand-charcoal sm:text-[13.5px]" data-id="element-60" data-mp="2jj7fw9uht23w">
                  {bonus.hook}
                </p>
                <p className="text-[12.5px] font-medium leading-snug text-brand-charcoal/80 sm:text-[13.5px]" data-id="element-61" data-mp="1qt8pob4kayxn">
                  {bonus.lead}
                </p>
                <Chips items={bonus.bullets} data-id="element-62" data-mp="1vsk77mcr68ga" />
                {bonus.notes.map(note => <p key={note} className="text-[12.5px] font-medium leading-snug text-brand-charcoal/70 sm:text-[13.5px]" data-id="element-63" data-mp="20ptuowgl0a1h">
                    {note}
                  </p>)}
                <p className="mt-auto border-t border-brand-sand/50 pt-2 text-[12.5px] font-extrabold uppercase leading-snug tracking-wide text-brand-clay sm:text-[13.5px]" data-id="element-64" data-mp="3h5en7ri6l8jy">
                  {bonus.close}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}